export const BuildInfo = {timestamp:1778178703000}
